import { Alert as MuiAlert, Box } from '@mui/material'
import type { ReactNode } from 'react'

import { colors, defaultTextColor, theme } from '../../Theme'

export type AlertType = 'warning' | 'success'

type AlertProps = {
  text: string
  secondaryText?: string
  children?: ReactNode
  icon?: ReactNode
  type: AlertType
}

export const Alert = ({ text, secondaryText, children, icon, type }: AlertProps) => {
  return (
    <Box sx={{ overflow: 'hidden' }}>
      <MuiAlert
        severity={type}
        icon={icon ?? false}
        action={children}
        sx={{
          backgroundColor: type === 'success' ? colors.alertGreen : colors.alertYellow,
          color: defaultTextColor({ theme }),
          borderRadius: 0,
          padding: `${theme.spacing.sizes.small} ${theme.spacing.sizes.normal}`,
          alignItems: 'center',
          width: '100%',
          maxWidth: '100%',
          boxSizing: 'border-box',
          minHeight: '4.125rem',
          '& .MuiAlert-icon': {
            padding: 0,
            marginRight: theme.spacing.sizes.smaller,
            color: 'inherit',
            opacity: 1,
          },
          '& .MuiAlert-message': {
            padding: 0,
            flex: '1 1 auto',
            minWidth: 0,
            overflow: 'visible',
          },
          '& .MuiAlert-action': {
            padding: 0,
            margin: `0 0 0 ${theme.spacing.sizes.smaller}`,
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'row',
            gap: theme.spacing.sizes.small,
          },
        }}
      >
        <Box
          component="p"
          sx={{
            margin: 0,
            fontFamily: theme.font.content,
            fontSize: theme.font.normal,
            fontWeight: 'medium',
            lineHeight: '1.5em',
            minWidth: 0,
            wordBreak: 'break-word',
            [`@media (max-width: ${theme.breakpoints.tiny})`]: {
              fontSize: theme.font.small,
            },
          }}
        >
          {text}
        </Box>
        {secondaryText && (
          <Box
            component="span"
            sx={{
              fontFamily: theme.font.content,
              fontSize: theme.font.normal,
              fontWeight: 'bold',
              lineHeight: '1.5em',
              color: defaultTextColor({ theme }),
            }}
          >
            {secondaryText}
          </Box>
        )}
      </MuiAlert>
    </Box>
  )
}
